import Button from 'atoms/button'
import { useState, useEffect } from 'react';
import { Col, Form, InputGroup } from 'react-bootstrap'

export default function PartnerSearch({
  onSearchSubmitted = () => {},
  onMaxResultsChanged = () => {},
  onSpecialismChanged = () => {},
  specialisms = [],
}) {
  const [autocompleteItems, setAutoCompleteItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if(searchTerm.toLowerCase().startsWith('zeela') && (searchTerm.toLowerCase().endsWith('ela') || searchTerm.toLowerCase().endsWith('elan') || searchTerm.toLowerCase().endsWith('eland')) && searchTerm.indexOf(' ') < 0) {
      setAutoCompleteItems([
        'Provincie Zeeland',
        'Zeeland Noord-Brabant',
      ]);
    } else if(autocompleteItems.length) {
      setAutoCompleteItems([]);
    }
  }, [searchTerm]);

  return (
    <>
      <Form>
        <Form.Row>
          <InputGroup as={Col} className="col-12 col-lg-6 mb-2">
            <Form.Control
              className="field-darker"
              type="text"
              placeholder="Postcode of plaatsnaam..."
              onChange={(event) => setSearchTerm(event.target.value)}
              onKeyPress={event => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  onSearchSubmitted(searchTerm)
                }
              }}
              value={searchTerm}
            />
            <InputGroup.Append>
              <Button
                style={{ height: '38px', marginTop: 0 }}
                onClick={() => onSearchSubmitted(searchTerm)}
              >Zoek</Button>
            </InputGroup.Append>
            {autocompleteItems.length ? <div className="autocomplete-items">
              {autocompleteItems.map(item => <div key={item} onClick={() => { setSearchTerm(item); onSearchSubmitted(item) }} className="autocomplete-item">{ item }</div>)}
            </div> : ''}
          </InputGroup>
          <Form.Group as={Col} className="col-12 col-lg-3">
            <Form.Control
              as="select"
              defaultValue="all"
              onChange={evt => onSpecialismChanged(evt.target.value)}
            >
              <option value="all">Alle specialismen</option>
              {specialisms.map(specialism => (<option key={`specialism-filter-${specialism.id}`} value={specialism.id}>{specialism.title.rendered}</option>))}
            </Form.Control>
          </Form.Group>
          <Form.Group as={Col} className="col-12 col-lg-3">
            <Form.Control
              as="select"
              defaultValue="25"
              onChange={evt => onMaxResultsChanged(evt.target.value)}
            >
              <option value="10">10 resultaten</option>
              <option value="25">25 resultaten</option>
              <option value="50">50 resultaten</option>
            </Form.Control>
          </Form.Group>
        </Form.Row>
      </Form>
      <style jsx global>{`
        .autocomplete-items {
          position: absolute;
          border: 1px solid #d4d4d4;
          z-index: 99;
          background: #fff;
          top: 37px;
          left: 5px;
          right: 68px;
          border-radius: 0.25rem;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        .autocomplete-item {
          padding: 5px 5px 5px 10px;
          cursor: pointer;
        }
      `}</style>
    </>
  )
}
